/**
 * This file contains a list of Australian airports (IATA codes).
 * Used for LE Business Traveller to determine when "Price includes GST" applies to flight offers.
 */
const AUSTRALIAN_AIRPORTS = [
  'SYD',
  'MELALL',
  'MEL',
  'BNE',
  'OOL',
  'CBR',
  'ADL',
  'PER',
  'HBA',
  'DRW',
  'NTL',
  'CFS',
  'DBO',
  'PPP',
  'PHE',
  'KNX',
  'KTA',
  'KGI',
  'GET',
  'BME',
  'MGB',
  'BHQ',
  'ASP',
  'AVV',
  'WGA',
  'TSV',
  'TMW',
  'ROK',
  'PQQ',
  'MQL',
  'MKY',
  'MCY',
  'LST',
  'HTI',
  'ISA',
  'HLT',
  'GLT',
  'GFF',
  'EMD',
  'DPO',
  'CNS',
  'BXG',
  'BNK',
  'ARM',
  'ALH',
  'BQB',
  'DCN',
  'EPR',
  'LEA',
  'MJK',
  'ONS',
  'PBO',
  'RVT',
  'ZNE',
  'AYQ',
  'CED',
  'CPD',
  'ELC',
  'GOV',
  'GTE',
  'KGC',
  'MGT',
  'MCV',
  'MNG',
  'OLP',
  'PLO',
  'PUG',
  'WYA',
  'ABM',
  'ABX',
  'BCI',
  'AUU',
  'BDB',
  'BEU',
  'BHS',
  'BKQ',
  'BQL',
  'BUC',
  'BVI',
  'BWT',
  'CAZ',
  'CMA',
  'CNJ',
  'CTL',
  'CUQ',
  'DGE',
  'DMD',
  'EDR',
  'GFN',
  'HGD',
  'HID',
  'HVB',
  'IVR',
  'JCK',
  'KRB',
  'KNS',
  'KWM',
  'LSY',
  'LRE',
  'MEB',
  'MIM',
  'MOV',
  'MRZ',
  'MYA',
  'NAA',
  'NRA',
  'ONG',
  'NTN',
  'OAG',
  'OOM',
  'PKE',
  'PTJ',
  'RCM',
  'RMA',
  'SGO',
  'TRO',
  'ULP',
  'WEI',
  'WIN',
  'WNR',
  'WOL',
  'WTB',
  'XTG',
  'SNB',
  'LDH',
  'HIS',
  'ZBL',
  'CCK',
  'XCH',
  'SIX',
  'TWB',
] as const;

export const AUSTRALIAN_AIRPORT_CODES: ReadonlySet<string> = new Set(AUSTRALIAN_AIRPORTS);
